<!--
* @description  参数1
* @fileName  companyDetails
* @author userName
* @date 2024-01-02 17:41:31
!-->
<template>
  <div id="companyDetails" class="companyDetails">
    <div class="basic-data one">
      <div class="basic-left">
        <div class="basic-info">
          <div class="basic-title">公司名称</div>
          <div class="basic-content">{{ dataForm.customerName }}</div>
        </div>
        <div class="basic-info">
          <div class="basic-title">发货频率</div>
          <div class="basic-content">{{ dataForm.monthlyInternational }}</div>
        </div>
        <div class="basic-info">
          <div class="basic-title">所在国家</div>
          <div class="basic-content">{{ dataForm.countryName }}</div>
        </div>
        <div class="basic-info">
          <div class="basic-title">所在城市</div>
          <div class="basic-content">{{ dataForm.cityName }}</div>
        </div>
      </div>
      <div class="basic-right">
        <button
          class="basic-right-btn"
          @click="
            () => {
              isDetailEdit = true;
            }
          "
        >
          <span>编辑</span>
        </button>
      </div>
    </div>
    <DetailEdit
      v-if="isDetailEdit"
      ref="DetailEdit"
      :is-show="isDetailEdit"
      @close="
        () => {
          isDetailEdit = false;
        }
      "
      @refresh="refresh"
    />
  </div>
</template>

<script>
import { GetCurrCustomer } from '../../../api/user.js'
import DetailEdit from './detailEdit.vue'
import { getCookie } from '@/utils/cookiejs'
export default {
  name: 'CompanyDetails',
  components: {
    // 组件的引用
    DetailEdit
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      isDetailEdit: false,
      dataForm: {},
      token: ''
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  mounted() {
    // 页面进入时加载内容
  },
  created() {
    // 实例被创建之后执行代码
    this.token = getCookie('token')
    if (this.token) {
      this.getCurrCustomer()
    }
  },
  methods: {
    refresh(isrRefresh) {
      if (isrRefresh) this.getCurrCustomer()
    },
    getCurrCustomer() {
      GetCurrCustomer().then((res) => {
        if (res.code === 200) {
          this.dataForm = res.data
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.basic-data {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  margin: 16px 0;
  padding: 16px 0;

  .basic-left {
    .basic-info {
      display: flex;

      .basic-title {
        margin-left: 24px;
        text-align: left;
        width: 357px;
        height: 44px;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 40px;
      }

      .basic-content {
        height: 44px;
        line-height: 40px;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #333333;
        margin-left: 24px;
      }
    }
  }

  .basic-right {
    margin-right: 24px;

    button {
      outline: none;
      border: none;
      width: 72px;
      height: 32px;
      background: transparent;
      border-radius: 8px;
			transition: all 0.3s;

      span {
        display: inline-block;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #3370ff;
        line-height: 22px;
        text-align: center;
        font-style: normal;
      }

			&:hover{
				cursor: pointer;
				background: rgba(51,112,255,0.08);
			}
    }
  }
}
</style>
